import Vue from 'vue'
import VueRouter from 'vue-router'
import {getItem} from '@/helpers/persistanceStorage'
import {nameToken} from '@/helpers/vars'
import {routes} from '@/router/router-1'
import {routes as routersTwo} from '@/router/router-2'
import vue$ from '@/main'
import {getterTypes} from '@/store/modules/auth'
import PageNotFound from '@/views/404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [
    ...routes,
    ...routersTwo,
    {path: '/404', name: 'pageNotFound', component: PageNotFound},
    {path: '*', name: '404', component: PageNotFound},
  ],
})

router.beforeEach((to, from, next) => {
  const isToken = getItem(nameToken)
  vue$.then((vue) => {
    const currentSchoolId = vue.$store.getters[getterTypes.currentSchoolId]
    const {name} = to

    if (to.matched.some((record) => record.meta.auth && !isToken)) {
      return next('/auth/login')
    } else if (
      (name === 'trainingGroupAthletes' || name === 'trainingSchedule') &&
      currentSchoolId === 'all'
    ) {
      return next('/404')
    }
    next()
  })
})

export default router
